const modes = { table: 'table', cards: 'cards' };

export default modes;